import createStore from "@/utils/create-store";
import Model from "@/models/admin/tree-adoptions";

export default createStore({ Model });
